var BALLOON_POSITIONS = ['top', 'bottom', 'left', 'right'];
var BALLOON_ALIGNMENTS = ['start', 'end'];
var BALLOON_SIZES = ['content-fit', 'medium', 'large'];

export { BALLOON_ALIGNMENTS, BALLOON_POSITIONS, BALLOON_SIZES };
